module.exports = __webpack_public_path__ + "static/marissa-bw@2x-3bf93677cc72fefcb62205ccf6745e70.png";